import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { Icon } from "../../../../components/Component"
import { useGetRTSInfo } from "../../../../customHooks/useGetViewedProducts";
import "../_style/styles.scss";

const ProductInfoModal = ({ id, isOpen, close, productName }) => {
  const { rtsInfo, loading, refetch } = useGetRTSInfo(id);
  console.log("rtsInfo", rtsInfo);
  return (
    <Modal isOpen={true} toggle={close} on>
      <ModalHeader
        close={
          <button className="close" onClick={close}>
            <Icon name="cross" />
          </button>
        }
      >
        {"Size Availability and Shipping Timeline"}
      </ModalHeader>
      <ModalBody>
        <div className="tableWrapper">
          {rtsInfo && rtsInfo?.list.length ? (
            <table className="table">
              <thead>
                <tr>
                  {Object.keys(rtsInfo?.list[0]).map((key) => <th>{key}</th>)}
                </tr>
              </thead>
              <tbody>
                {rtsInfo?.list.map((objs, i) => (
                  <tr key={i}>
                    {Object.keys(objs).map((key, j) => (
                      <td key={`${i}_${j}`}>{objs[key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : "loading..."}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ProductInfoModal;

